<template>
  <div class="mascot-panel">
    <div class="mascot-container">
      <img :src="currentImageSrc" alt="Mascot" class="mascot-image" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MascotPanel',
  data() {
    return {
      currentType: 'idle', // 'idle' or 'speak'
      currentFrame: 1,
      totalFrames: {
        idle: 100,
        speak: 55
      },
      timer: null,
      fps: 20 // Frames per second
    }
  },
  computed: {
    currentImageSrc() {
      // Pad frame number with leading zeros to 3 digits
      const frameStr = this.currentFrame.toString().padStart(3, '0');
      return `/static/animals/${this.currentType}/processed_frame_${frameStr}.png`;
    }
  },
  mounted() {
    this.startAnimation();
  },
  beforeUnmount() {
    this.stopAnimation();
  },
  methods: {
    startAnimation() {
      this.stopAnimation();
      const interval = 1000 / this.fps;
      
      this.timer = setInterval(() => {
        this.currentFrame++;
        const maxFrames = this.totalFrames[this.currentType];
        
        if (this.currentFrame > maxFrames) {
          this.currentFrame = 1;
        }
      }, interval);
    },
    stopAnimation() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    playAnimation(type) {
      if (this.currentType === type) return;
      
      if (this.totalFrames[type]) {
        this.currentType = type;
        this.currentFrame = 1;
        this.startAnimation();
      } else {
        console.warn(`Animation type '${type}' not found.`);
      }
    }
  },
  expose: ['playAnimation'] // Expose method for parent component
}
</script>

<style scoped>
.mascot-panel {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  background: rgba(255, 255, 255);
}

.mascot-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.mascot-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  /* Optional: Add a drop shadow for better separation from background */
  filter: drop-shadow(0 10px 20px rgba(0,0,0,0.1));
}
</style>
